// extracted by mini-css-extract-plugin
export default {"container":"PixelatedImage_container__48WvA","canvas":"PixelatedImage_canvas__T3-LR","loader":"PixelatedImage_loader__OopQ5","error":"PixelatedImage_error__kw2IN"};